import React from 'react';
import ReactDOM from 'react-dom/client';
import DraftGuide from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DraftGuide />
  </React.StrictMode>
);
